import { PERIOD } from '@pages/Clients/ClientsList/constants/periods';

import type { NClientsList } from '@pages/Clients/ClientsList/ClientsList.types';

export const adaptFiltersForServer = (serverFilters: NClientsList.Filters) => {
  const { VisitsFilter, ClientsFilter } = serverFilters;
  const visitsFilterLogicalGroups: Array<NClientsList.VisitsFilterUnit[]> = [];
  const clientsFilterLogicalGroups: Array<NClientsList.ClientsFilterUnit[]> =
    [];
  let logicalGroupCounterByVisits = 0;
  let logicalGroupCounterByClients = 0;
  const errors: string[] = [];

  VisitsFilter.forEach((item: NClientsList.VisitsFilterUnit) => {
    const { IsAnd } = item;

    const itemAsIncludedVisitFilter = {
      ...item,
      IsInclude: true,
    };

    if (IsAnd === true) {
      return (visitsFilterLogicalGroups[logicalGroupCounterByVisits] = [
        ...(visitsFilterLogicalGroups[logicalGroupCounterByVisits] || []),
        itemAsIncludedVisitFilter,
      ]);
    } else if (IsAnd === false) {
      logicalGroupCounterByVisits++;

      return (visitsFilterLogicalGroups[logicalGroupCounterByVisits] = [
        ...(visitsFilterLogicalGroups[logicalGroupCounterByVisits] || []),
        itemAsIncludedVisitFilter,
      ]);
    }
  });

  ClientsFilter.forEach(
    (item: NClientsList.ClientsFilterUnit, index: number) => {
      const { IsAnd } = item;
      const isIncludedTagsGroupIndex = (index + 1) % 2 === 0;
      const itemAsIncludedClientFilter = {
        ...item,
        IsInclude: isIncludedTagsGroupIndex,
      };
      let itemWithHandledBirthDay = itemAsIncludedClientFilter;
      const Values = item?.Values?.[0];

      if (Values === undefined) {
        return errors.push(
          `Объект клиентского фильтра даты рождения с индексом ${index} не найден`
        );
      }

      if (Values?.DateStart || Values?.DateEnd) {
        itemWithHandledBirthDay = {
          ...itemWithHandledBirthDay,
          Values: [
            {
              ...itemWithHandledBirthDay?.Values?.[0],
              Birthday: PERIOD,
            },
          ],
        };
      }

      if (IsAnd === true) {
        return (clientsFilterLogicalGroups[logicalGroupCounterByClients] = [
          ...(clientsFilterLogicalGroups[logicalGroupCounterByClients] || []),
          itemWithHandledBirthDay,
        ]);
      } else if (IsAnd === false) {
        if (!ClientsFilter[index + 1]?.IsAnd) {
          logicalGroupCounterByClients++;
        }

        return (clientsFilterLogicalGroups[logicalGroupCounterByClients] = [
          ...(clientsFilterLogicalGroups[logicalGroupCounterByClients] || []),
          itemWithHandledBirthDay,
        ]);
      }
    }
  );

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const joinedLogicalGroups: any = [
    {
      VisitsFilter: [],
      ClientsFilter: [],
    },
  ];
  visitsFilterLogicalGroups.forEach(
    (item: NClientsList.VisitsFilterUnit[], index: number) => {
      return (joinedLogicalGroups[index] = {
        ...joinedLogicalGroups[index],
        VisitsFilter: item,
      });
    }
  );
  clientsFilterLogicalGroups.forEach(
    (item: NClientsList.ClientsFilterUnit[], index: number) => {
      return (joinedLogicalGroups[index] = {
        ...joinedLogicalGroups[index],
        ClientsFilter: item,
      });
    }
  );

  const serverRequestChunk = {
    Filters: joinedLogicalGroups,
    Errors: errors,
  };

  return serverRequestChunk;
};
